export enum SENDER_TYPE {
  END_USER = 'END_USER',
  HUMAN_AGENT = 'HUMAN_AGENT',
  VIRTUAL_AGENT = 'VIRTUAL_AGENT',
  SUPERVISOR = 'SUPERVISOR'
}
